import { useEffect, useState } from 'react';

import FiltersDisclosure from '~/shared/components/filters/FiltersDisclosure';
import { SelectOption } from '~/shared/utils/types';
import Typography from '~/shared/components/Typography';
import Switch from '~/shared/components/Switch';

import SearchRuleID from './SearchRuleID';

interface FilterPanelContentProps {
  panelOpen?: boolean;
  pendingAutoscaleState: string[];
  setPendingAutoscaleState: (state: string[]) => void;
  pendingRuleIDFilters: SelectOption[];
  setPendingRuleIDFilters: (filters: SelectOption[]) => void;
  showActiveRulesOnly: boolean;
  setShowActiveRulesOnly: (activeOnly: boolean) => void;
}

export default function FilterPanelContent({
  panelOpen = false,
  // pendingAutoscaleState,
  // setPendingAutoscaleState,
  pendingRuleIDFilters,
  setPendingRuleIDFilters,
  showActiveRulesOnly,
  setShowActiveRulesOnly,
}: FilterPanelContentProps) {
  const [isRuleIDDisclosureOpen, setIsRuleIDDisclosureOpen] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    if (!panelOpen) {
      setHasInitialized(false);
      return;
    }

    if (hasInitialized) {
      return;
    }

    // Check if Rule ID disclosure should be open based on filters
    const shouldOpenRuleID = pendingRuleIDFilters.length > 0;

    const hasAnyOpen = isRuleIDDisclosureOpen || shouldOpenRuleID;

    if (shouldOpenRuleID) {
      setIsRuleIDDisclosureOpen(true);
    }

    // Default to Rule ID if nothing is open
    if (!hasAnyOpen) {
      setIsRuleIDDisclosureOpen(true);
    }

    setHasInitialized(true);
  }, [panelOpen, hasInitialized, pendingRuleIDFilters?.length, isRuleIDDisclosureOpen]);

  return (
    <div className="flex-1 overflow-y-auto pb-4">
      <ActiveRulesToggle
        activeOnly={showActiveRulesOnly}
        setActiveOnly={() => setShowActiveRulesOnly(!showActiveRulesOnly)}
      />

      <FiltersDisclosure
        title="Rule ID"
        count={pendingRuleIDFilters.length > 0 ? pendingRuleIDFilters?.length : undefined}
        className="px-10 border-b border-gray-300"
        open={isRuleIDDisclosureOpen}
        onOpenChange={setIsRuleIDDisclosureOpen}
      >
        <SearchRuleID
          initialSelections={pendingRuleIDFilters}
          onSelectionsChange={setPendingRuleIDFilters}
          isDisclosureOpen={isRuleIDDisclosureOpen}
        />
      </FiltersDisclosure>
    </div>
  );
}

function ActiveRulesToggle({
  activeOnly,
  setActiveOnly,
}: {
  activeOnly: boolean;
  setActiveOnly: (activeOnly: boolean) => void;
}) {
  return (
    <div className="flex flex-col px-10 py-3 gap-3">
      <Typography fontWeight={600} variant="p2-semi" color="font-family-outfit text-primary-900 ">
        Active rules
      </Typography>
      <div className="flex justify-between items-center">
        <Typography fontWeight={400} variant="p2-semi" color="font-family-inter text-primary-900 ">
          Show active rules only
        </Typography>
        <Switch checked={activeOnly} onChange={() => setActiveOnly(!activeOnly)} />
      </div>
    </div>
  );
}
